define('views/components/cd_role/cd_roles',['require','views/base/collection_view','views/components/cd_role/cd_role_list','text!templates/base/collection.html'],function(require){

    var BaseCollectionView = require('views/base/collection_view');
    var ListView = require('views/components/cd_role/cd_role_list');

    var temp = require("text!templates/base/collection.html");
    return BaseCollectionView.extend({
        template: _.template(temp),
        className: 'grid-container cd-roles-grid-container',

        onRender: function () {
            this.ListContainer.show(new ListView({
                collection: this.collection
            }));
        }
    });
});
